import {TierSelect} from '@client/pages/public/enroll/components/TierSelect';
import type {ProductCategory} from '@client/pages/public/enroll/types';

/** The "Pricing for" bar shown above a product's plan cards, scoped to that product's tier. */
export function TierFilter({category}: {category: ProductCategory}) {
  return (
    <div className='flex flex-wrap items-center gap-x-4 gap-y-3 rounded-xl border border-neutral-200 bg-white px-5 py-4'>
      <span className='text-sm font-semibold text-neutral-700'>Pricing for</span>
      <TierSelect category={category} />
    </div>
  );
}
